import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Log } from 'ng2-logger';
import { InsertionCycle } from '@app/shared/models/insertion-cycle.model';
import { TableConfig } from '@app/shared/util/table-config.utils';

@Component({
    selector: 'app-insertion-cycles-table',
    templateUrl: './insertion-cycles-table.component.html',
    styleUrls: ['./insertion-cycles-table.component.scss']
})
export class InsertionCyclesTableComponent {
    _logger = Log.create(InsertionCyclesTableComponent.name);

    @Input() insertionCycles: InsertionCycle[];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        this.rowClick.emit(clickedItem);
    }

}
